import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "@/store/";

import Homepage from "@/pages/homepage/components/index.vue";
import getLocale from "@/utils/locale";

import "@/styles/book.scss";

export default (abTestCategories = {}) => {
  const rootElement = document.getElementById("vue-homepage");

  if (!rootElement) {
    return;
  }

  Vue.use(VueI18n);

  const { categoryProps } = rootElement.dataset;

  store.dispatch("layout/load", abTestCategories);

  return new Vue({
    name: "HomepageRoot",
    i18n: new VueI18n({
      locale: getLocale()
    }),
    el: rootElement,
    store,
    render: h => h(Homepage, {
      props: {
        categoryProps: JSON.parse(categoryProps),
        abTestCategories: abTestCategories
      }
    })
  });
};
